import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import { Sidebar, buildHelpTopics } from '../../Common/HelpCenter';
import { TRYK_BRODERI_TITLE, TRYK_BRODERI_ITEMS } from './trykBroderiData';
import { CATEGORIES } from './faqData';
import { HELP_LABELS, HELP_ROUTES } from './helpConfig';
import '../../Common/HelpCenter/HelpCenter.css';
import './TrykBroderi.css';

const CLSDKTrykBroderi = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const prev = document.documentElement.getAttribute('data-brand');
    document.documentElement.setAttribute('data-brand', 'CLS');
    return () => {
      if (prev) document.documentElement.setAttribute('data-brand', prev);
      else document.documentElement.removeAttribute('data-brand');
    };
  }, []);

  const topics = buildHelpTopics({
    context: 'trykBroderi',
    categories: CATEGORIES,
    labels: HELP_LABELS,
    routes: HELP_ROUTES,
    navigate,
  });

  return (
    <div className="helpcenter">
      <Header showTopBar={false} />
      <main className="helpcenter__main">
        <div className="helpcenter__container">
          <div className="helpcenter__list-col">
            <h1 className="helpcenter__title typo-h1">{TRYK_BRODERI_TITLE}</h1>
            <p className="helpcenter__lede typo-body-lg">
              Se eksempler på tryk og broderi, som kan tilføjes jeres tøj.
            </p>

            <div className="tryk-broderi__grid">
              {TRYK_BRODERI_ITEMS.map((item) => (
                <div className="tryk-broderi__item" key={item.id}>
                  <div className="tryk-broderi__image">
                    <img src={item.image} alt={item.name} />
                  </div>
                  <p className="tryk-broderi__label typo-h6">{item.name}</p>
                </div>
              ))}
            </div>
          </div>

          <Sidebar
            title={HELP_LABELS.sidebarTitle}
            topics={topics}
            activeId="trykBroderi"
            dividerBeforeId={HELP_ROUTES.claims ? 'claims' : 'contact'}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CLSDKTrykBroderi;
